const tracksIT = {
    "view": {
        "table": {
            "title": "Modifica Tracce",
            "column": {
                "name": "Nome",
                "mixName": "Nome Mix",
                "mixLength": "Durata Mix",
                "player": "Lettore",
                "status": "Stato",
                "accStatus": "Stato Acc",
                "qc": "QC",
                "action": "Azione"
            },
            "button": {
                "edit": "Modifica",
                "goToReleases": "Vai alle Pubblicazioni",
                "distribute": "Distribuisci",
                "submitEditing": "Invia Modifiche",
                "statusReady": "Pronto",
                "statusNotReady": "Non Pronto"
            },
            "message": {
                "identityNotCheckedTooltip": "Non hai ancora fornito le tue informazioni complete, quindi non puoi distribuire le pubblicazioni. Per farlo, gentilmente Invia le Tue Informazioni.",
                "tracksNotReadyTooltip": "Si prega di inviare i metadati per tutte le Tracce per distribuire la Pubblicazione.",
                "tracksNotReadyForEditingTooltip": "Si prega di inviare i metadati per tutte le tracce, per inviare le modifiche.",
                "distributionDisabledPreScanInProgressTooltip": "Si prega di attendere che il pre-scan sia completato prima di distribuire la pubblicazione.",
                "distributionDisabledPreScanNotDoneTooltip": "Si prega di eseguire il pre-scan prima di distribuire la pubblicazione.",
                "distributionDisabledPreScanDeclarationNotSubmittedTooltip": "Si prega di inviare la dichiarazione del pre-scan prima di distribuire la pubblicazione.",
                "browserNotSupported": "Il tuo browser non supporta l'elemento audio.",
                "trackUpdated": "La traccia è stata aggiornata!"
            },
            "modal": {
                "distribute": {
                    "header": "Sei sicuro che tutte le informazioni inserite siano valide e rappresentino completamente questa pubblicazione?",
                    "body": {
                        "point1": "Dopo questa azione, la tua pubblicazione sarà controllata e se le informazioni sono corrette sarà distribuita nelle date di distribuzione ufficiali ed esclusive.",
                        "point2": "Confermando e accettando questo modulo, accetti pienamente e ti conformi ai <1>Termini di Distribuzione</1>, <3>Termini di Utilizzo</3> e <5>Informativa sulla Privacy</5>.",
                        "point3": "Confermando e accettando questo modulo, confermi indiscutibilmente che la pubblicazione del contenuto inviato con i relativi asset, file audio e metadati, appartiene esclusivamente a te o è completamente concessa in licenza alla tua etichetta.",
                        "point4": "Con la presente accetti pienamente che sarai l'unico responsabile per qualsiasi informazione fuorviante, uso non autorizzato, attività illegale o qualsiasi tipo di disputa.",
                        "flaggedTracksTerms": {
                            "header": "Termini Tracce Segnalate",
                            "point1": "Si prega di notare: <strong>'{{releaseName}}'</strong> contiene una o più tracce segnalate, si applica una tariffa di <strong>15 €</strong> per traccia segnalata per consegnare la pubblicazione a <strong>Spotify</strong>. Poiché hai scelto di non pagare questa tariffa al momento, la pubblicazione non sarà consegnata a Spotify. Confermando e accettando questo modulo, riconosci e accetti questi termini.",
                            "point2": "In futuro, se scegli di consegnare la pubblicazione a <strong>Spotify</strong>, puoi andare alla sezione Segnalate nella tabella delle Pubblicazioni e seguire le istruzioni di pagamento."
                        },
                        "artificialStreamingDeclaration": {
                            "header": "Dichiarazione di Streaming Artificiale",
                            "point1": "<strong>1.</strong> Comprendo e accetto pienamente di non impegnarmi in alcuna forma di streaming artificiale, inclusi l'uso di bot, farm di streaming o qualsiasi metodo che manipoli le metriche DSP.",
                            "point2": "<strong>2.</strong> Non pagherò né offrirò pagamenti per posizionamenti in playlist, né lavorerò con terze parti che promettono posizionamenti garantiti — capisco che questo è considerato frode e truffa.",
                            "point3": "<strong>3.</strong> Riconosco che tali azioni possono comportare la cessazione immediata, la perdita di royalties, rivendicazioni legali, penali contrattuali e commissioni, e la segnalazione ai DSP e alle autorità.",
                            "point4": "<strong>4.</strong> Garantisco inoltre di informare ed educare qualsiasi artista o cliente con cui lavoro su queste regole e di assicurarmi che le rispettino.",
                            "point5": "<strong>5.</strong> Capisco che se mi impegno nello streaming artificiale, i miei dati KYC, inclusi nome completo, indirizzo, carta d'identità e altre informazioni personali, possono essere condivisi con i dipartimenti legali dei DSP, come quelli di Spotify, Apple Music e altri.",
                            "point6": "<strong>6.</strong> Accetto la piena responsabilità legale per qualsiasi violazione.",
                            "acknowledgment": "Con la presente riconosco e accetto di rispettare i suddetti termini di Streaming Artificiale, e accetto la piena responsabilità legale per qualsiasi violazione."
                        }
                    },
                    "button": {
                        "cancel": "Annulla",
                        "confirm": "Conferma e Accetta"
                    }
                },
                "finishEditing": {
                    "header": "Sei sicuro che tutte le informazioni inserite siano valide e rappresentino completamente questa pubblicazione?",
                    "body": {
                        "point1": "Dopo questa azione, la tua pubblicazione sarà controllata e se le informazioni sono corrette sarà ridistribuita ai partner DSP. <strong>NOTA, solo i METADATI saranno inviati ai DSP, contenuti come IMMAGINI e file AUDIO non possono essere aggiornati in questo modo.</strong>",
                        "point2": "Confermando e accettando questo modulo, accetti pienamente e ti conformi ai <1>Termini di Utilizzo</1> e ai Termini del nostro Accordo di Distribuzione Esclusiva.",
                        "point3": "Confermando e accettando questo modulo, accetti pienamente e ti conformi all'<1>Informativa sulla Privacy</1>.",
                        "point4": "Confermando e accettando questo modulo, confermi indiscutibilmente che la pubblicazione del contenuto inviato con i relativi asset, file audio e metadati, appartiene esclusivamente a te o è completamente concessa in licenza alla tua etichetta.",
                        "point5": "Con la presente accetti pienamente che sarai l'unico responsabile per qualsiasi informazione fuorviante, uso non autorizzato, attività illegale o qualsiasi tipo di disputa."
                    },
                    "button": {
                        "cancel": "Annulla",
                        "confirm": "Conferma e Accetta"
                    }
                }
            }
        }
    },
    "update": {
        "form": {
            "label": {
                "title": "Modifica traccia {{trackName}}",
                "mandatoryMetadata": "Metadati Obbligatori",
                "required": "Obbligatorio",
                "trackName": "Nome Traccia",
                "mixName": "Nome Mix",
                "originalmix": "Mix Originale",
                "remix": "Questo è un Remix o Mix",
                "vocals": "Voci",
                "genre": "Genere",
                "subGenre": "Sotto-Genere",
                "additionalMetadata": "Metadati Aggiuntivi",
                "copyright": "Copyright ©",
                "copyrightYear": "Anno di Copyright",
                "albumOnly": "Solo Album",
                "explicitContent": "Contenuto Esplicito",
                "isrc": "ISRC",
                "daIsrc": "Dolby Atmos ISRC",
                "generateIsrc": "Genera ISRC",
                "trackLanguageMetadata": "Metadati Lingua Traccia",
                "language": "Lingua",
                "autoDetectLanguage": "Rilevamento Automatico (Lingua)",
                "accountingData": "Dati Contabili",
                "labelShare": "Quota Etichetta (%)"
            },
            "placeholder": {
                "select": "Seleziona...",
                "labelShare": "es. 50"
            },
            "help_text": {
                "trackName": "Titolo della traccia",
                "mixName": "Inserisci il nome del mix senza parentesi. Alcune tracce sono rilasciate in più versioni. Questo campo descrive la versione, ad esempio 'Bunte Bummler - Aesub (Monika Ross Remix)",
                "vocals": "Ascolta la tua traccia per intero. Se la tua traccia ha delle voci, seleziona la lingua delle voci. Se la tua traccia è priva di voci, seleziona l'opzione Strumentale. Controlla due volte per essere sicuro. Se questo input è errato, alcuni negozi come iTunes e Apple Music rifiuteranno la pubblicazione.",
                "publishers": {
                    "publisherName": "<strong>Nome dell'editore:</strong> Inserisci il nome completo della casa editrice se utilizzi servizi editoriali.  Se non utilizzi servizi editoriali ufficiali, inserisci/seleziona <strong>Copyright Control</strong>. Si prega di <strong>non inserire il nome della tua etichetta</strong> se non è una casa editrice registrata. Potrebbero applicarsi implicazioni legali.",
                    "authorSongWriterName": "<strong>Nome completo dell'autore / compositore:</strong> Inserisci il <strong>vero nome e cognome</strong> della persona."
                },
                "contributors": {
                    "contributorsName": "<strong>Nome dei contributori:</strong> Inserisci il <strong>vero nome e cognome</strong> della persona.",
                    "contributorsRoles": "<strong>Ruoli dei contributori:</strong> Almeno un contributore deve essere aggiunto come <strong>Compositore</strong>. Se la tua traccia contiene voci, almeno un contributore deve essere aggiunto come <strong>Compositore</strong> e un contributore deve essere aggiunto come <strong>Paroliere</strong>."
                },
                "copyright": "Nome del titolare del copyright",
                "albumOnly": "Indica se la traccia sarà venduta solo come parte di una pubblicazione in bundle. Nota che alcuni negozi potrebbero ignorare questa istruzione",
                "explicitContent": "Si prega di contrassegnare questo campo se la traccia ha testi proibiti",
                "isrc": "Il Codice Standard Internazionale di Registrazione assegnato alla traccia. Se non ne hai uno tuo, ne genereremo uno per te",
                "daIsrc": "Il Codice Standard Internazionale di Registrazione assegnato alla traccia. Se non ne hai uno tuo, ne genereremo uno per te",
                "language": "In quale lingua è scritto il nome della traccia? Si prega di controllare due volte se non sei sicuro. Se questo input è errato, alcuni negozi come iTunes e Apple Music rifiuteranno la pubblicazione.",
                "labelShare": "<strong>Consiglio:</strong> Lo standard del settore per la <strong>quota etichetta</strong> è <strong>50%</strong> e <strong>50%</strong> per i <strong>partecipanti</strong>. Ti consigliamo vivamente di inserire la percentuale di condivisione accurata su cui hai concordato con i tuoi artisti, partecipanti e partner.",
                "costTypes": {
                    "point1": "Inserisci solo i <strong>Costi</strong> effettivi, verificati o pre-concordati per traccia. Ti consigliamo vivamente di non inserire costi falsi.",
                    "point2": "<strong>Tipi di costi</strong> potrebbero essere qualsiasi costo fisso o variabile, ad esempio <strong>Masterizzazione Audio, Design Grafico, Promozione, Marketing</strong>, o qualsiasi altra spesa valida sostenuta per la particolare <strong>Traccia</strong> dall'<strong>Etichetta</strong>."
                }
            },
            "button": {
                "submitTrack": "Invia Traccia"
            },
            "message": {
                "successArtistAdded": "Un nuovo Artista è stato aggiunto!",
                "successPublisherAdded": "Un nuovo Editore è stato aggiunto!",
                "successContributorAdded": "Un nuovo Contributore è stato aggiunto!",
                "successShareholderAdded": "Un nuovo Partecipante è stato aggiunto!",
                "successCostTypeAdded": "Un nuovo Tipo di Costo è stato aggiunto!",
                "errorLabelShareInvalid": "Si prega di inserire un valore valido (1-100)",
                "errorFormCannotBeSubmitted": "Il modulo non può essere inviato! Si prega di compilare tutti i campi e controllare gli errori!",
                "accountingMetadata": {
                    "title": "ATTENZIONE",
                    "description": {
                        "point1": "METADATI OPZIONALI - compila questa parte dei metadati solo se emetterai rapporti contabili ai tuoi artisti o partecipanti!",
                        "point2": "Assicurati che i dati inviati in questa sezione siano completamente accurati, poiché influenzeranno i rapporti che invierai ai tuoi artisti e partecipanti.",
                        "point3": "Ti consigliamo vivamente di ricontrollare gli input poiché dopo l'invio, ulteriori modifiche e cambiamenti non sono raccomandati per motivi di accuratezza dei dati.",
                        "point4": "I rapporti contabili per i tuoi artisti e partecipanti avranno un effetto accurato solo se invii tutti i parametri correttamente e in base agli accordi con i tuoi artisti e partecipanti.",
                        "point5": "I costi possono essere aggiunti solo una volta e non possono essere modificati successivamente per motivi di trasparenza e accuratezza. Assicurati di inserire accuratamente tutti i costi delle tracce al primo tentativo."
                    }
                }
            }
        }
    },
    "publishersRow": {
        "form": {
            "label": {
                "publishers": "Editori",
                "required": "Obbligatorio",
                "order": "Ordine",
                "publisherName": "Nome Editore",
                "authorSongWriterName": "Nome completo Autore / Compositore"
            },
            "placeholder": {
                "publisherName": "Seleziona Editore..."
            },
            "button": {
                "addAnother": "Aggiungi un altro",
                "createNew": "Crea nuovo?",
                "remove": "Rimuovi"
            },
            "message": {
                "publisherRequired": "Si prega di selezionare l'editore",
                "authorSongWriterRequired": "Si prega di inserire il vero nome e cognome della persona."
            },
            "modal": {
                "header": "Aggiungi nuovo Editore",
                "body": {
                    "label": {
                        "name": "Nome"
                    },
                    "message": {
                        "nameRequired": "Il nome è obbligatorio",
                        "publisherAlreadyExists": "L'editore esiste già"
                    }
                },
                "button": {
                    "createNew": "Crea nuovo",
                    "cancel": "Annulla"
                }
            }
        }
    },
    "contributorsRow": {
        "form": {
            "label": {
                "contributors": "Contributori",
                "required": "Obbligatorio",
                "order": "Ordine",
                "contributorName": "Nome completo Contributore",
                "contributorRole": "Ruolo Contributore"
            },
            "placeholder": {
                "contributorName": "Seleziona Contributore..."
            },
            "button": {
                "addAnother": "Aggiungi un altro",
                "createNew": "Crea nuovo?",
                "remove": "Rimuovi"
            },
            "modal": {
                "header": "Aggiungi nuovo Contributore",
                "body": {
                    "label": {
                        "name": "Nome"
                    },
                    "help_text": {
                        "name": "Si prega di inserire il nome e cognome completo del compositore. Esempio: 'Max Mustermann'"
                    },
                    "message": {
                        "nameRequired": "Il nome è obbligatorio",
                        "nameMustNotBeInUppercase": "Il nome non deve essere tutto in maiuscolo",
                        "insertRealName": "Si prega di inserire il vero nome e cognome della persona.",
                        "errorContributorAlreadyExists": "Il contributore esiste già"
                    }
                },
                "button": {
                    "createNew": "Crea nuovo",
                    "cancel": "Annulla"
                }
            }
        }
    },
    "shareholdersRow": {
        "form": {
            "label": {
                "order": "Ordine",
                "shareholders": "Partecipanti",
                "shareholderName": "Nome Partecipante",
                "shareholderSplit": "Quota Partecipante (%)",
                "shareholderRoles": "Ruoli Partecipante"
            },
            "placeholder": {
                "shareholderName": "Seleziona Partecipante...",
                "shareholderSplit": "es. 50"
            },
            "message": {
                "shareholderRequired": "Si prega di selezionare il partecipante",
                "shareholderSplitRequired": "Si prega di inserire un valore valido (1-100)",
                "shareholderRolesRequired": "Si prega di selezionare almeno un ruolo",
                "shareSum": "La Quota Etichetta e le Quote dei Partecipanti devono sommare il 100%"
            },
            "button": {
                "addAnother": "Aggiungi un altro",
                "createNew": "Crea nuovo?",
                "remove": "Rimuovi"
            },
            "modal": {
                "header": "Aggiungi nuovo Partecipante",
                "body": {
                    "label": {
                        "name": "Nome",
                        "email": "Email"
                    },
                    "help_text": {
                        "name": "Si prega di inserire il nome e cognome completo del compositore. Esempio: 'Max Mustermann'"
                    },
                    "message": {
                        "nameRequired": "Il nome è obbligatorio",
                        "emailRequired": "L'email è obbligatoria",
                        "emailInvalid": "L'email non è valida"
                    }
                },
                "button": {
                    "createNew": "Crea nuovo",
                    "cancel": "Annulla"
                }
            }
        }
    },
    "costTypesRow": {
        "form": {
            "label": {
                "costTypes": "Tipi di Costo",
                "order": "Ordine",
                "costType": "Tipo di Costo",
                "cost": "Costo (€)"
            },
            "placeholder": {
                "costType": "Seleziona Tipo di Costo...",
                "cost": "es. -7.5"
            },
            "button": {
                "addAnother": "Aggiungi un altro",
                "createNew": "Crea nuovo?",
                "remove": "Rimuovi"
            },
            "message": {
                "costTypeRequired": "Si prega di selezionare il tipo di costo",
                "costNotNegative": "Si prega di inserire un valore negativo es. -10.0"
            },
            "modal": {
                "header": "Aggiungi Nuovo Tipo di Costo",
                "body": {
                    "label": {
                        "name": "Nome"
                    },
                    "message": {
                        "nameRequired": "Il nome è obbligatorio",
                        "costTypeAlreadyExists": "Il tipo di costo esiste già"
                    },
                    "button": {
                        "createNew": "Crea nuovo",
                        "cancel": "Annulla"
                    }
                }
            }
        }
    }
};

export default tracksIT;